module.exports = __webpack_public_path__ + "static/media/Abhisek.2a9dc994.png";